import Link from "next/link";
import { Footer } from "@nju/feature-portal-footer";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { salesRoutes } from "@nju/routes";
import { A, BlockContent, InfoPanel, LayoutWrapper, Separator } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function ClientInProgress() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent spacing="xl">
        <ClientSideOnly>
          <InfoPanel
            description="spróbuj później"
            icon="exclamation-circle"
            title="ktoś w tym samym <br> czasie obsługuje tego klienta..."
          >
            <div className="flex justify-center">
              <Link href={salesRoutes.statusKlienta.get()} passHref={true}>
                <A size={{ "@onlyMobile": "s" }}>powrót</A>
              </Link>
            </div>
          </InfoPanel>
          <Separator size="l" tone="invisible" />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
